import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（経営状況） 設定", -1)
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "hospital-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#hospital-panel",
      role: "tab",
      "aria-controls": "hospital-panel"
    }, "病院")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "clinic-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#clinic-panel",
      role: "tab",
      "aria-controls": "clinic-panel"
    }, "診療所")
  ])
], -1)
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "hospital-panel",
  role: "tabpanel",
  "aria-labelledby": "hospital-tab"
}
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "clinic-panel",
  role: "tabpanel",
  "aria-labelledby": "clinic-tab"
}
const _hoisted_9 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_keiei_jokyo_setting_item = _resolveComponent("keiei-jokyo-setting-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hospitalItems, (item) => {
                return (_openBlock(), _createBlock(_component_keiei_jokyo_setting_item, {
                  key: item.item.id,
                  item: item,
                  onChangeInput: _cache[0] || (_cache[0] = (v) => _ctx.onChangeInput(_ctx.hospitalClinicKbnType.Hospital, v))
                }, null, 8, ["item"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinicItems, (item) => {
                return (_openBlock(), _createBlock(_component_keiei_jokyo_setting_item, {
                  key: item.item.id,
                  item: item,
                  onChangeInput: _cache[1] || (_cache[1] = (v) => _ctx.onChangeInput(_ctx.hospitalClinicKbnType.Clinic, v))
                }, null, 8, ["item"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}